<mat-card appearance="outlined" id="debug-mode-card">
  <mat-card-header>
    <mat-card-title>
      {{ cardTitleKey | translate }}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content class="card-regular">
    <mat-card-subtitle>
      {{ cardSubTitleKey | translate }}
    </mat-card-subtitle>
  </mat-card-content>
  <mat-card-actions>
    <form id="debug-mode-form">
      <mat-label id="debug-mode-label">
        {{ toggleLabelKey | translate }}
      </mat-label>
      <mat-slide-toggle
        id="debug-mode-toggle"
        name="debug-mode"
        aria-label="Debug Mode"
        [disabled]="disableButton$ | async"
        [checked]="toggleEnabled$ | async"
        (change)="toggleVal($event.checked)"
      >
        {{ toggleStatusKey$ | async | translate }}
      </mat-slide-toggle>
    </form>
  </mat-card-actions>
</mat-card>
